import { DetalleProducto } from "./DetalleProducto";
import { RecepcionCamion } from "./RecepcionCamion";
import { RecepcionCombustibleContenedor } from "./RecepcionCombustibleContenedor";
import { Responsable } from "./Responsable";

export class Recepcion {
    guid: string;
    codigoTerminal: string;
    codigoAeroplanta: string;
    prefijoRecibo: number;
    numeroRecibo: number;
    responsableDto: Responsable;
    detalleCamion: RecepcionCamion;
    recepcionCombustibleContenedores: RecepcionCombustibleContenedor[];
    estadoRemito: number;
    detalleProductos: DetalleProducto[];
    prefijoRemitoCargamento: number;
    numeroRemitoCargamento: number;
    firmaOperador: string;
    firmaConductor: string;
    pathRemitoFisico: string;
    fechaHoraCreacion: string;
    detalles?: DetalleProducto[];
    recepciones?: RecepcionCombustibleContenedor[];
}